
import {
  PASSCODE_SUBMIT,
  RESEND_CODE,
  UPDATE_RESEND_CODE_TIMER,
  RESET_SUCCESS_STATE,
  RESEND_PASSWORD_RECOVERY_CODE,
  RECOVERY_PASSCODE_SUBMIT
} from './constants';

export function passcodeSubmit(passCode, userGuid, factorId) {
  return {
    type: PASSCODE_SUBMIT,
    data: { passCode },
    userGuid, factorId
  };
}

export function resendCode(userGuid, factorId, data) {
  return {
    type: RESEND_CODE,
    data,
    userGuid, factorId
  };
}

export function resendPasscodeToRecoverPasswd(stateToken) {
  return {
    type: RESEND_PASSWORD_RECOVERY_CODE,
    data: { stateToken }
  };
}

export function submitRecoveryPasscode(stateToken, passcode) {
  return {
    type: RECOVERY_PASSCODE_SUBMIT,
    data: { stateToken, passCode: passcode }
  };
}


export function resetSuccessState() {
  return {
    type: RESET_SUCCESS_STATE
  };
}

export function updateResendCodeInterval(interval) {
  return {
    type: UPDATE_RESEND_CODE_TIMER,
    data: interval
  };
}

